import { http } from 'vue'

export default {
  loadSubcategories (context, params) {
    const companyIdParam = (params.companyId) ? '&company_id=' + params.companyId : ''
    return http.get('subcategories?category_id=' + params.categoryId + '&with=counter&sort=name' + companyIdParam)
  },
  // load client from the API server
  loadSubcategory (context, params = {}) {
    let withParam = params.with ? '?with=' + params.with : ''
    let companyIdParam = params.companyId ? '&company_id=' + params.companyId : ''
    return http.get('subcategories/' + params.id + withParam + companyIdParam)
  },
  saveSubcategories (context, payload) {
    context.commit('SAVE_SUBCATEGORIES', payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/subcategories/actions.js